import { useQuery, UseQueryResult } from 'react-query';
import apiFetch, { defaultApiFetchErrorHandler, HTTPError } from 'react-scale/lib/api-fetch';
import { GetWorkerSkillsResult, WorkerSkillResponse } from '@scale/genai-data-service-client';

export const useFetchAllWorkerSkills = (
  tree?: boolean,
  treeLevels?: number,
  onSuccess?: (res: WorkerSkillResponse[]) => void,
  options?: { enabled?: boolean },
): UseQueryResult<WorkerSkillResponse[], unknown> => {
  return useQuery(
    ['fetchAllWorkerSkills', tree, treeLevels],
    async () => {
      const response = await apiFetch<GetWorkerSkillsResult>(null, '/corp-api/worker-skills', {
        method: 'GET',
        query: {
          tree,
          treeLevels,
        },
      });

      return response.workerSkills;
    },
    {
      onSuccess,
      onError: (err: HTTPError) => defaultApiFetchErrorHandler(err, { handleHttp: true }),
      enabled: options?.enabled ?? false,
    },
  );
};
